import FilterListingItemContentMeta from './FilterListingItemContentMeta';

export default FilterListingItemContentMeta;
